<template>
  <div>
    <v-app-bar app dense absolute dark color="#00ACC1">
      <v-app-bar-nav-icon 
        @click.stop="menu_lateral.abierto = !menu_lateral.abierto"  
        v-if="vista.nombre == '/distribuidor'" 
        :style="{'color': `white;`}" 
      >
      </v-app-bar-nav-icon>

      <div 
        v-if="this.$route.path !='/distribuidor' && this.$route.path !='/verificar'" 
        @click="regresar_pagina"
      >
        <v-btn icon>
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
      </div>

      <div v-if="pagina !='Home' " class="ml-4 text-truncate" >  {{ this.$route.name}} </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <MenuLateral />
  </div>
</template>
<script>
import Vista from "@/objetos/vista";
import Menu_lateral from '@/objetos/menu_lateral.js'  
import MenuLateral from "@/components/MenuLateral/MenuLateral.vue"
import CrossSiteRedirect from '@/../../frontend_pedidos_web/src/funciones/app/cross_site_redirect.js'

export default {
  data: () => ({
    pagina: null,
    menu_lateral: Menu_lateral,
    pagina_params: null,
    vista: Vista
  }),
  components:{
    MenuLateral
  },
  methods: {
    regresar_pagina() {
      CrossSiteRedirect.goBack(this);
      //CrossSiteRedirect.tryReturn(this, function(){
      //   this.$router.go(-1);
      //});
    },

    action_click(nombre) {
      let ruta = `/${nombre.toLowerCase()}`;
      this.$router.push(ruta);
    }
  }
};
</script>

<style scoped>
.azul-degradado {
  background: linear-gradient(
    to right,
    rgb(88, 196, 181) 0%,
    rgb(16, 128, 213) 100%
  ) !important;
}
.barra {
  text-transform: capitalize;
  font-size: 13px;
}
</style>
